import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Loading from '../common/Loading.js';
import ResultItem from './ResultItem';
import Advert from '../common/Advert.js';
import ErrorMessage from '../common/ErrorMessage.js';

class Results extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.loadNextPage = this.loadNextPage.bind(this);
    }

    componentDidMount() {  

    }   

    loadNextPage() {
        this.props.actions.browseGigs(this.props.results.lastPage + 1);
    }

    render() {
        return (
            this.props.loadingStatus ? 
                (this.props.loadingStatus.status == 'LOADING' && this.props.loadingStatus.page == 1  ?
                <Loading />
                :
                <React.Fragment>
                    <div className="tbl-header" />
                    <div id="resultsContainer">
                        {this.props.results.items && this.props.results.items.length > 0 ? 
                            <React.Fragment>
                                <div className="gigs">
                                    {
                                        this.props.results.items.map(item => <ResultItem key={item.ID} item={item} />)
                                    }                            
                                </div>
                                {this.props.results.haveNextPage ?
                                    this.props.loadingStatus.status == 'LOADING' && this.props.loadingStatus.page > 1 ?
                                        <Loading /> :
                                        <div id="divLoadNext" style={{textAlign:'center'}}>
                                            <button id="btnLoadNext" className="btn btn-outline transition" style={{marginTop:'15px'}} onClick={this.loadNextPage}>Show More...</button>
                                        </div>
                                    : null
                                }
                            </React.Fragment>
                            :
                            this.props.loadingStatus.status === 'FAILED' ?
                                <ErrorMessage error="Sorry, something went wrong, unable to load gigs" />
                                :
                                <p style={{textAlign:'center', paddingTop:'10px'}}>{`No upcoming gigs found`}</p>
                        }
                        <div className="extcontent" style={{ textAlign: 'center' }}>
                            <Advert key={this.props.results.lastPage} adType="Footer" />
                        </div>
                    </div>
                </React.Fragment>
                )
            : null
        );
    }
}

Results.propTypes = {
    results: PropTypes.object.isRequired,   
    actions: PropTypes.object.isRequired,
    loadingStatus: PropTypes.object
};

export default Results;


